export const calculateDimension = (uniqueId, imgDimension) => {
    let clientWidth = 0;
    let clientHeight = 0;
    let originalImgWidth = 0;
    let originalImgHeight = 0;

    if(uniqueId){
      const imageZoomWrapper = document.getElementById(uniqueId);
      clientWidth = imageZoomWrapper?.offsetWidth;
      clientHeight = imageZoomWrapper?.offsetHeight;
      originalImgWidth = imgDimension.width;
      originalImgHeight = imgDimension.height;
    }

    if(!clientWidth || !clientHeight || !originalImgWidth || !originalImgHeight){
      return;
    }

    const width = originalImgWidth > clientWidth ? clientWidth : originalImgWidth;
    const height = originalImgHeight > clientHeight ? clientHeight : originalImgHeight;

    const canvasWidth = width;
    const canvasHeight = height;

    const ratio = Math.min(clientWidth / originalImgWidth, clientHeight / originalImgHeight);
    const rtnWidth = Math.floor(originalImgWidth * ratio);
    const rtnHeight = Math.floor(originalImgHeight * ratio);
    const canvasDrawDimension = {
        width: rtnWidth > canvasWidth ? canvasWidth : rtnWidth,
        height: rtnHeight > canvasHeight ? canvasHeight : rtnHeight
    };

    const canvasDimension = {
      width: canvasWidth,
      height: canvasHeight
    };

    return {canvasDimension, canvasDrawDimension};
}

export const generateCanvas = ({img, canvasId, canvasDrawDimension, canvasDimension}) => {
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvasDimension.width, canvasDimension.height);
    ctx.drawImage(img, 0, 0, canvasDrawDimension.width, canvasDrawDimension.height);
    return canvas;
}